import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import { Track } from 'angieslist-app-platform';
import { Button } from 'angieslist-react-components';
import ReactTruncate from 'react-truncate';
import './ImageIndexCard.scss';
import { ServiceProviderImage } from '../../../../app/common/images/imagesService';
import EditSingleImageModalForm from '../../../showcase/browser/components/EditSingleImageModalForm';


type Props = {
 image: ServiceProviderImage,
 onRemove: (image: ServiceProviderImage, event: any) => any,
 updateImage: (values: Object) => void,
 updateImageReset: () => void,
 updateImageError: Object,
 updateImageLoading: Object,
};

const ImageIndexCard = ({
  image,
  onRemove,
  updateImage,
  updateImageReset,
  updateImageError,
  updateImageLoading,
}: Props) => {
  const fallbackImage = (
    <div className="image-index-card-image" />
  );
  const displayImgUrlCORSSafe = `${image.url}?q=${image.id}`;

  return (
    <div id="Image-index-card">
      <div id={`index-card-image-${image.id}`}>
        <div>
          <ReactImageFallback
            src={displayImgUrlCORSSafe}
            alt={image.caption}
            fallbackImage={fallbackImage}
            className="image-index-card-image"
          />
        </div>
      </div>
      <div
        id={`image-index-card-title-${image.id}`}
        className="image-index-card-title-container"
      >
        <div className="image-index-card-title">
          <If condition={image.caption}>
            <ReactTruncate lines={2}>{image.caption}</ReactTruncate>
          </If>
          <If condition={!image.caption}>
            <ReactTruncate className="image-index-card-untitled" lines={2}>Untitled</ReactTruncate>
          </If>
        </div>
      </div>

      <div className="image-index-card-button-row">
        <div id={`image-index-card-edit-section-left-${image.id}`} className="image-index-card-edit-section-left">
          <div>
            <EditSingleImageModalForm
              updateShowcaseMediaReset={updateImageReset}
              updateShowcaseMedia={updateImage}
              updateShowcaseMediaError={updateImageError}
              updateShowcaseMediaIsLoading={updateImageLoading}
              mediaId={image.id}
              imagePath={image.url}
              imageDescription={image.caption}
              rotationEnabled={false}
            />
          </div>
        </div>
        <div id={`image-index-card-edit-section-right-${image.id}`} className="image-index-card-edit-section-right">
          <Track>
            <Button
              id={`image-index-card-remove-button-${image.id}`}
              data-track-activity-location="SP : My Business : delete image"
              bsStyle="link"
              bsSize="small"
              className="remove-button"
              onClick={event => onRemove(image, event)}
            >Delete
            </Button>
          </Track>
        </div>
      </div>
    </div>
  );
};

export default ImageIndexCard;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/ImageIndexCard.js